// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Switch from "@mui/material/Switch";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
// import MDButton from "components/MDButton";
// import BasicLayout from "layouts/authentication/components/BasicLayout";
// import bgImage from "assets/images/bg-sign-in-basic.jpeg";
// import logo from "assets/images/doorsharp-logo.png"; // Import your logo image
// import axios from "axios"; // Import Axios

// function Basic() {
//   // const [rememberMe, setRememberMe] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState(""); // To display error message
//   const navigate = useNavigate();

//   // const handleSetRememberMe = () => setRememberMe(!rememberMe);

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     // Prepare the login data
//     const loginData = {
//       email: email,          // Email from the form
//       password: password,    // Password from the form
//     };

//     // Make an API call to check if the username (email) exists in the DB
//     try {
//       const response = await axios.post("http://localhost:9000/api/user/login", loginData, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       if (response.status === 200) {
//         const { accessToken } = response.data;

//         // Store access token in localStorage
//         localStorage.setItem("accessToken", accessToken);

//         // If rememberMe is true, save the credentials
//         // if (rememberMe) {
//         //   localStorage.setItem("email", email);
//         // }

//         console.log("Login successful, access token stored");

//         // Redirect to the dashboard
//         navigate("/dashboards/analytics");
//         window.location.reload(); // Reload page to apply token-based access
//       } else {
//         setError("Invalid email or password.");
//       }
//     } catch (error) {
//       setError("An error occurred. Please try again.");
//       console.error("Login error:", error);
//     }
//   };

//   return (
//     <BasicLayout image={bgImage}>
//       <MDBox
//         position="absolute"
//         top="20px"
//         left="20px"
//       >
//         <img src={logo} alt="Logo" width="100px" />
//       </MDBox>

//       <MDBox
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         height="100vh"
//         sx={{
//           backgroundImage: `url(${bgImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <MDBox
//           p={3}
//           borderRadius="lg"
//           width="100%"
//           maxWidth="350px"
//           textAlign="center"
//           sx={{
//             backdropFilter: "blur(1px)", // Add glassmorphism effect
//             backgroundColor: "rgba(255, 255, 255, 0)", // Transparent white
//             boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.5)", // Soft shadow effect
//           }}
//         >
//           <MDTypography variant="h4" fontWeight="medium" color="white" mt={1} mb={2}>
//             Sign in
//           </MDTypography>
//           {error && (
//             <MDTypography variant="caption" color="error" fontWeight="bold">
//               {error}
//             </MDTypography>
//           )}

//           <MDBox component="form" role="form" onSubmit={handleLogin}>
//             <MDBox mb={2}>
//               <MDInput 
//                 type="email" 
//                 label="Email" 
//                 fullWidth 
//                 required
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 InputLabelProps={{
//                 style: { color: 'black', fontWeight: "bold" }, // Change label color to black
//                 }}
//               />
//             </MDBox>
//             <MDBox mb={2}>
//               <MDInput 
//                 type="password" 
//                 label="Password" 
//                 fullWidth 
//                 required
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 InputLabelProps={{
//                 style: { color: 'black', fontWeight: "bold" }, // Change label color to black
//                 }}
//               />
//             </MDBox>

//             <MDBox mt={4} mb={1}>
//                 <MDButton variant="gradient" color="info" fullWidth type="submit">
//                   Sign in
//                 </MDButton>
//             </MDBox>
//           </MDBox>
//         </MDBox>
//       </MDBox>
//     </BasicLayout>
//   );
// }

// export default Basic;


import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import logo from "assets/images/doorsharp-logo.png";
import CircularProgress from "@mui/material/CircularProgress";

// MSAL imports
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "authConfig";

function Basic() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // MSAL hooks
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Check for error message passed from callback
  useEffect(() => {
    if (location.state && location.state.error) {
      setError(location.state.error);
    }
  }, [location.state]);

  // Check authentication status synchronously - redirect immediately if authenticated
  useEffect(() => {
    // Check if user is already authenticated
    if (isAuthenticated && accounts.length > 0) {
      const account = accounts[0];
      // Store user info in localStorage
      localStorage.setItem("userInfo", JSON.stringify({
        name: account.name,
        email: account.username,
      }));
      navigate("/dashboards/my-dashboard", { replace: true });
      return;
    }

    // Check for access token in localStorage
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      navigate("/dashboards/my-dashboard", { replace: true });
      return;
    }
    // If not authenticated, show sign-in form (no loading state needed)
  }, [isAuthenticated, accounts, navigate]);

  // Handle form login (placeholder)
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("Please use Microsoft Sign-in");
  };

  // Microsoft login handler using MSAL redirect (more reliable than popup)
  const handleMicrosoftLogin = async () => {
    setIsLoading(true);
    setError("");

    try {
      // Use loginRedirect - avoids COOP/popup blocking issues
      await instance.loginRedirect({
        ...loginRequest,
        prompt: "select_account", // Force account selection
      });
      // Note: The page will redirect, so code after this won't execute
      // The auth callback will handle storing tokens and redirecting to dashboard
      
    } catch (error) {
      console.error("Microsoft login error:", error);
      setError(error.message || "Microsoft login failed. Please try again.");
      setIsLoading(false);
    }
  };


  // Redirect to dashboard if accessToken is already present
  // useEffect(() => {
  //   const token = localStorage.getItem("accessToken");
  //   if (token) {
  //     navigate("/dashboards/analytics");
  //   }
  // }, [navigate]);

  // const onFormSubmit = async (formData) => {
  //   setLoading(true);
  //   setError(""); // Clear any previous errors
  
  //   // Prepare the login data
  //   const loginData = {
  //     email: formData.name,          // Email from the form
  //     password: formData.passcode,   // Password from the form
  //     // company: selectedCompany,      // Company name (stored as label in state)
  //   };

  //   // Make an API call to check if the username (email) exists in the DB
  //   try {
  //     const response = await axios.post(process.env.REACT_APP_API_URL+"/user/login", loginData, {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (response.status === 200) {
  //       const { accessToken } = response.data;

  //       // Store access token in localStorage
  //       localStorage.setItem("accessToken", accessToken);

  //       console.log("Login successful, access token stored");

  //       // Redirect to the dashboard
  //       navigate("/dashboards/analytics");
  //       window.location.reload(); // Reload page to apply token-based access
  //     } else {
  //       setError("Invalid email or password.");
  //     }
  //   } catch (error) {
  //     setError("An error occurred. Please try again.");
  //     console.error("Login error:", error);
  //   }
  // };

  return (
    <BasicLayout image={bgImage}>
      {/* Optional logo at top-left */}
      <MDBox position="absolute" top="20px" left="20px">
        {/* <img src={logo} alt="Logo" width="100px" /> */}
      </MDBox>

      {/* Centered container */}
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <MDBox
          p={4}
          borderRadius="lg"
          width="100%"
          maxWidth="380px"
          textAlign="center"
          sx={{
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
          }}
        >
          {/* Title */}
          <MDTypography
            variant="h4"
            fontWeight="medium"
            mb={1.5}
            sx={{ color: "#000000" }}
          >
            Sign in
          </MDTypography>

          <MDTypography>
          {/* Logo */}
          <img src={logo} alt="Logo" width="90px" />
          </MDTypography>

          {/* Error Message */}
          {error && (
            <MDBox
              variant="caption"
              color="error"
              fontWeight="normal"
              sx={{
                lineHeight: 1.5,
                fontSize: "0.85rem",
                textAlign: "center",
                mb: 2,
              }}
            >
              {error}
            </MDBox>
          )}

          {/* Hidden manual sign-in fields */}
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            <MDBox mb={2} sx={{ display: "none" }}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputLabelProps={{
                  style: { color: "black", fontWeight: "bold" },
                }}
              />
            </MDBox>

            <MDBox mb={2} sx={{ display: "none" }}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputLabelProps={{
                  style: { color: "black", fontWeight: "bold" },
                }}
              />
            </MDBox>

            <MDBox mt={3} mb={2} sx={{ display: "none" }}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                Sign in
              </MDButton>
            </MDBox>

            {/* Divider (hidden) */}
            <MDBox mt={2} mb={1} textAlign="center" sx={{ display: "none" }}>
              <MDTypography variant="caption" color="white" fontWeight="medium">
                OR
              </MDTypography>
            </MDBox>

            {/* Microsoft Sign-in Button */}
            <MDBox mt={2}>
              <MDButton
                variant="outlined"
                fullWidth
                onClick={handleMicrosoftLogin}
                disabled={isLoading}
                sx={{
                  borderColor: "#1672b9",
                  color: "#1672b9",
                  fontWeight: 500,
                  paddingY: 1,
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 185, 0.1)",
                    borderColor: "#1672b9",
                  },
                  "&:disabled": {
                    borderColor: "#ccc",
                    color: "#999",
                  },
                }}
              >
                <MDBox
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap={1}
                  sx={{ color: isLoading ? "#999" : "#1672b9" }}
                >
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zM24 11.4H12.6V0H24v11.4z" />
                    </svg>
                  )}
                  {isLoading ? "Signing in..." : "Sign In With Microsoft"}
                </MDBox>
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDBox>
    </BasicLayout>

  );
}

export default Basic;
